import { Link } from "eddev/routing"
import { JournalTileFragment, ProjectTileFragment } from "../../types.graphql"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { Chip } from "@components/atoms/Chip"
import { Appear } from "@components/motion/Appear"
import { Button } from "@components/atoms/Button"
import dayjs from "dayjs"
import { cn } from "@utils/tw"

export const JournalTile = ({ journal, className }: { journal: JournalTileFragment; className?: string }) => {
  return (
    <Appear className={cn("flex flex-col gap-5", className)}>
      <Link href={journal.uri} className="flex flex-col gap-5 group">
        <div className="w-full aspect-[328/244] md:aspect-square bg-grey-light relative overflow-hidden">
          {journal.journalHeader?.featuredImage?.mediaItemUrl && (
            <ResponsiveImage
              {...journal.journalHeader.featuredImage}
              className="absolute w-full h-full md:group-hover:scale-105 transition-transform duration-500"
              objectFit="cover"
            />
          )}
          {journal.journalHeader?.category && (
            <Chip className="absolute bottom-4 right-4">{journal.journalHeader.category.name}</Chip>
          )}
        </div>
        <div className="flex flex-col gap-4">
          <p className="type-mobile-body-body-xs md:type-desktop-body-body-xs text-stone700">
            {dayjs(journal.date).format("D MMMM YYYY")}
          </p>
          <p className="type-mobile-headings-heading-s md:type-desktop-headings-heading-s">{journal.title}</p>
        </div>
      </Link>
    </Appear>
  )
}
